module.exports = __webpack_public_path__ + "static/media/jdrManoir_01_thumb.cdfbdc91.png";